import { openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";
const _withScopeId = n => (_pushScopeId("data-v-020b8b1a"), n = n(), _popScopeId(), n);
const _hoisted_1 = ["data-poster", "src"];
const _hoisted_2 = ["data-plyr-provider", "data-plyr-embed-id"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "video-player-container",
        "data-external": "video-player-container-element",
        onMouseenter: _cache[1] || (_cache[1] =
            //@ts-ignore
            (...args) => (_ctx.handleMouseEnter && _ctx.handleMouseEnter(...args))),
        onMouseleave: _cache[2] || (_cache[2] =
            //@ts-ignore
            (...args) => (_ctx.handleMouseLeave && _ctx.handleMouseLeave(...args)))
    }, [
        (_ctx.isHTML5Video)
            ? (_openBlock(), _createElementBlock("video", {
                key: 0,
                ref: "playerRef",
                preload: "metadata",
                "data-poster": _ctx.thumbUrl,
                src: _ctx.videoPlayerType === _ctx.VideoPlayerType.Url ? _ctx.url : _ctx.videoStream,
                playsinline: "",
                onError: _cache[0] || (_cache[0] = ($event) => (_ctx.$emit('error')))
            }, null, 40, _hoisted_1))
            : (_ctx.isYouTubeOrVimeo)
                ? (_openBlock(), _createElementBlock("div", {
                    key: 1,
                    ref: "playerRef",
                    "data-plyr-provider": _ctx.playerProviderId,
                    "data-plyr-embed-id": _ctx.playerEmbedId
                }, null, 8, _hoisted_2))
                : _createCommentVNode("", true)
    ], 32));
}
